import { UI_CONSTANTS } from "../../../constants/ui";

export const getActivityImageFrameStyle = (size) => ({
  width: `${size}px`,
  height: `${size}px`,
  border: `1px solid ${UI_CONSTANTS.IMAGES.THUMBNAIL_BORDER_COLOR}`,
  borderRadius: `${UI_CONSTANTS.IMAGES.COLLECTION_THUMBNAIL_BORDER_RADIUS}px`,
  padding: `${UI_CONSTANTS.IMAGES.THUMBNAIL_FRAME_PADDING}px`,
  backgroundColor: "#FFFFFF",
  overflow: "hidden",
  flexShrink: 0,
});
